import { render, staticRenderFns } from "./polizas_admin.vue?vue&type=template&id=512799a9&scoped=true&"
import script from "./polizas_admin.vue?vue&type=script&lang=js&"
export * from "./polizas_admin.vue?vue&type=script&lang=js&"
import style0 from "./polizas_admin.vue?vue&type=style&index=0&id=512799a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512799a9",
  null
  
)

export default component.exports